import React, { useMemo } from "react";
import "antd/dist/antd.css";
import { Form, Input } from "antd";
import * as actions from "../../Store/Actions/index";
import { connect } from "react-redux";
import { formatNumber } from "../../Util/util";
import {
  getTotalTransitionCostMaxBreakIn,
  getTotalTransitionCostMinBreakIn,
  getInflateAdjustedSystemCostMaxBreakIn,
  getInflateAdjustedSystemCostMinBreakIn,
} from "../Logics/costAdjustCalculations";
import { inflationTooltip, yearsIntoFutureTooltip, inflationCalcTooltip } from "../../Util/writing";
import { getLabel, getHelp, getValidateStatus } from "../../Util/util";

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 24 },
    md: { span: 16 },
    lg: { span: 12 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 24 },
    md: { span: 8 },
    lg: { span: 12 },
  },
};

const outputFormDivStyle = {
  marginTop: 20,
  marginBottom: 5,
  padding: 25,
};

const TotalCosts = (props) => {
  const totalTransitionCostMinBreakIn = useMemo(
    () => getTotalTransitionCostMinBreakIn(),
    [props.retrainCostDetails, props.prodLossDetails, props.systemCostDetails]
  );

  const totalTransitionCostMaxBreakIn = useMemo(
    () => getTotalTransitionCostMaxBreakIn(),
    [props.retrainCostDetails, props.prodLossDetails, props.systemCostDetails]
  );

  const inflatedAdjustedCostMinBreakIn = useMemo(
    () => getInflateAdjustedSystemCostMinBreakIn(),
    [totalTransitionCostMinBreakIn, props.costAdjustDetails]
  );

  const inflatedAdjustedCostMaxBreakIn = useMemo(
    () => getInflateAdjustedSystemCostMaxBreakIn(),
    [totalTransitionCostMaxBreakIn, props.costAdjustDetails]
  );

  const updateCostAdjustAttr = (e) => {
    const inputField = e.currentTarget.id;
    const value = e.currentTarget.value;
    props.setCostAdjustAttr({ [inputField]: value });
  };

  return (
    <React.Fragment>
      <div style={outputFormDivStyle}>
        <Form {...formItemLayout}>
          <Form.Item
            label={getLabel("Inflation Rate", inflationTooltip)}
            validateStatus={getValidateStatus(props.costAdjustDetails["inflation-rate"])}
            help={getHelp(props.costAdjustDetails["inflation-rate"])}
            required
          >
            <Input
              addonAfter="%"
              placeholder=""
              id="inflation-rate"
              onChange={updateCostAdjustAttr}
              className="numberInput"
              value={props.costAdjustDetails["inflation-rate"]}
            />
          </Form.Item>

          <Form.Item
            label={getLabel("Years Into the Future", yearsIntoFutureTooltip)}
            validateStatus={getValidateStatus(props.costAdjustDetails["years-into-future"])}
            help={getHelp(props.costAdjustDetails["years-into-future"])}
            required
          >
            <Input
              addonAfter="Years"
              placeholder=""
              id="years-into-future"
              onChange={updateCostAdjustAttr}
              className="numberInput"
              value={props.costAdjustDetails["years-into-future"]}
            />
          </Form.Item>

          <Form.Item
            label={getLabel("Inflation Adjusted Total Cost Estimation (Minimum Break-in Period)", inflationCalcTooltip)}
            help=""
          >
            <Input
              addonAfter={props.currency}
              placeholder=""
              id="inflation-adjusted-cost-estimation-min-break-in"
              disabled
              value={formatNumber(inflatedAdjustedCostMinBreakIn)}
            />
          </Form.Item>

          <Form.Item
            label={getLabel("Inflation Adjusted Total Cost Estimation (Maximum Break-in Period)", inflationCalcTooltip)}
            help=""
          >
            <Input
              addonAfter={props.currency}
              placeholder=""
              id="inflation-adjusted-cost-estimation-max-break-in"
              disabled
              value={formatNumber(inflatedAdjustedCostMaxBreakIn)}
            />
          </Form.Item>
        </Form>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    currency: state.currency.currency,
    retrainCostDetails: state.costs.retrainCostDetails,
    prodLossDetails: state.costs.prodLossDetails,
    systemCostDetails: state.costs.systemCostDetails,
    costAdjustDetails: state.costs.costAdjustDetails,
    benefitsDetails: state.benefits.benefitsDetails,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCostAdjustAttr: (obj) => dispatch(actions.setCostAdjustAttr(obj)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TotalCosts);
